import React from 'react';
import PropTypes from 'prop-types';
import { SankeyBarChart } from '../charts/SankeyBarChart';
import { drawTimeline } from '../charts/Timeline';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import PlayIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import Button from '@material-ui/core/Button';
import HighLightIcon from '@material-ui/icons/AddAlert';
import FastForwardIcon from '@material-ui/icons/FastForward';
import FastRewindIcon from '@material-ui/icons/FastRewind';

import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './Journey.css';
import JourneyInsights from './JourneyInsights';

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightRegular,
        paddingLeft: 10
    },
    button: {
        margin: theme.spacing.unit,
    },
    input: {
        display: 'none',
    },
});

class JourneyDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            playing: false,
            total: -1
        }

        this.playButtonCallback = this.playButtonCallback.bind(this);
        this.playbackFinishedHandler = this.playbackFinishedHandler.bind(this);
        this.footerClickcallback = this.footerClickcallback.bind(this);
    }

    componentDidMount() {
        const total = this.props.data[0].enter.value;
        this.setState({ total: total });

        new SankeyBarChart(`#${this.props.id}-journey-viz`, `${this.props.id}-journey-viz-svg`, this.props.data, { height: 150 }, total, this.footerClickcallback);
        drawTimeline(`#${this.props.id}-timeline`, this.props.data, this.playButtonCallback, this.playbackFinishedHandler);
    }

    playButtonCallback(newData) {
        if (!newData || newData.length <= 0) return;

        new SankeyBarChart(`#${this.props.id}-journey-viz`,
            `${this.props.id}-journey-viz-svg`,
            newData,
            { height: 150 },
            this.state.total,
            this.footerClickcallback);
    }

    playButtonHandler(e) {
        const newPlayingValue = !this.state.playing;
        this.setState({ playing: newPlayingValue });
    }

    playbackFinishedHandler() {
        this.setState({ playing: false });
    }

    footerClickcallback(tabIndex) {
        console.log('tab index: ' + tabIndex);
        this.setState({ currentTab: tabIndex });
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div id={`${this.props.id}-journey-viz`} className="sankey-barchart">
                    <div className="header" width="100%" style={{ position: 'relative', display: 'block', clear: 'both' }} />
                    <svg id={`${this.props.id}-journey-viz-svg`} height="100%" width="100%">
                        <g className="x-lines" transform="translate(0,0)" />
                        <g className="y-lines" transform="translate(0,0)" />
                        <g className="y-text" transform="translate(0,0)" />
                        <g className="edges" transform="translate(0,0)" />
                    </svg>
                    <div className="footer" width="100%" style={{ position: 'relative', display: 'block', clear: 'both' }} />
                </div>
                <JourneyInsights currentTab={this.state.currentTab} />
                {/* <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <HighLightIcon />
                        <Typography className={classes.heading}>
                            Journey insights
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <JourneyInsights />
                    </ExpansionPanelDetails>
                </ExpansionPanel> */}
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <FastRewindIcon />
                        <Typography className={classes.heading}>Journey history</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <div id={`${this.props.id}-timeline`} style={{ position: 'relative', display: 'block', clear: 'both' }}>
                            <Button onClick={(e) => this.playButtonHandler(e)} data-on="false" variant="fab" id="play-button" className={classes.button} aria-label="Play" style={{ top: '5px', left: '5px', position: 'absolute' }}>
                                {this.state.playing ? <PauseIcon /> : <PlayIcon />}
                            </Button>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel disabled>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <FastForwardIcon />
                        <Typography className={classes.heading}>Simulated journey projection (not enough data)</Typography>
                    </ExpansionPanelSummary>
                </ExpansionPanel>
            </div>
        );
    }
}

JourneyDetail.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JourneyDetail);



// WEBPACK FOOTER //
// ./src/components/JourneyDetail.js